import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Order_history } from '../api/urls';
import { apiPublic } from '../api/api';


export const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiPublic.get(Order_history);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch orders');
    }
  }
);

// Cancel an Order
export const cancelOrder = createAsyncThunk(
  'orders/cancelOrder',
  async (orderId, { rejectWithValue }) => {
    try {
      await apiPublic.patch(`${Order_history}/${orderId}`, { status: 'cancelled' });
      return orderId;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to cancel order');
    }
  }
);



const initialState = {
  orders: [], 
  loading: false,
  error: null,
  cancelLoading: false,
  cancelError: null,
};



const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearOrders: (state) => {
      state.orders = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // 👉 Fetch Orders
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.orders = payload;
      })
      .addCase(fetchOrders.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })

      
      .addCase(cancelOrder.pending, (state) => {
        state.cancelLoading = true;
        state.cancelError = null;
      })
      .addCase(cancelOrder.fulfilled, (state, { payload: orderId }) => {
        state.cancelLoading = false;
        state.orders = state.orders.map(order =>
          order.id === orderId ? { ...order, status: 'cancelled' } : order
        );
      })
      .addCase(cancelOrder.rejected, (state, { payload }) => {
        state.cancelLoading = false;
        state.cancelError = payload;
      });
  },
});


export const { clearOrders } = orderSlice.actions;
export default orderSlice.reducer;
